<div class="allOpenCloseArea">
  <button class="button" (click)="allOpenClose()">{{isFullOpenName}}</button>
</div>

<mat-accordion #myaccordion="matAccordion" multi="true">
  <mat-expansion-panel class="panel" *ngFor="let item of items">
    <mat-expansion-panel-header class="header">
      <mat-panel-title class="title">
        {{ item.title }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-panel-description class="data">
      <div [innerHTML]="item.data"></div>
    </mat-panel-description>
  </mat-expansion-panel>
</mat-accordion>
